import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigAdmin";
import Constant from "../../constants";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";

export default class ViewOperationsUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      datatable: {
        columns: [
          {
            label: "Name",
            field: "operations_user_name",
            sort: "asc",
            width: 150,
          },
          {
            label: "Email",
            field: "email",
            sort: "asc",
            width: 200,
          },
          {
            label: "Mobile Number",
            field: "mobile_number",
            sort: "asc",
            width: 150,
          },
          {
            label: "Status",
            field: "status",
            sort: "asc",
            width: 100,
          },
          {
            label: "Actions",
            field: "actions",
            sort: "asc",
            width: 10,
          },
        ],
        rows: [],
      },
    };
  }

  // To get details after first render
  componentDidMount = () => {
    this.fetchOperationsUsers();
  };

  // For getting the data
  fetchOperationsUsers() {
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/Operations/getAllOperationsList",
      {}
    )
      .then((response) => {
        const users = response.data.data || [];
        const assignvalues = users.map((item) => ({
          operations_user_name: item.name,
          email: item.email,
          mobile_number: item.mobile_number,
          status: item.status == 1 ? "Active" : "In-Active",
          actions: (
            <div>
              <span>
                <Link
                  to={"/admin/CreateOperationsUser/" + item.id}
                  className="fa fa-edit point-cursor"
                  title={"Update " + item.name}
                ></Link>
              </span>{" "}
              &nbsp;
            </div>
          ),
        }));

        const nextState = Object.assign({}, this.state);
        nextState.datatable.rows = assignvalues;
        nextState.loaded = true;
        this.setState(nextState);
      })
      .catch((error) => {
        //  Only the Super Admin tier may manage roles - the server answers
        //  everyone else with 403.
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to manage operations users.");
        }
        this.setState({ loaded: true });
      });
  }

  render() {
    const { datatable, loaded } = this.state;
    return (
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <ol className="breadcrumb">
                    <li className="active">
                      <Link to="/admin"> Dashboard</Link>&gt; Operations Users
                      &gt;
                      <span> Operations Users List </span>
                    </li>
                  </ol>
                </div>
              </div>

              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="tab-header">
                        <h3> Operations Users List </h3>
                      </div>
                      <div id="reg_form">
                        <form>
                          <div className="row">
                            <div className="form-group col-md-12">
                              <Link
                                to="/admin/CreateOperationsUser"
                                className="btn  btn-primary fright"
                              >
                                Create Operations User
                              </Link>
                            </div>
                          </div>
                        </form>
                        {!loaded ? (
                          <p>Loading............</p>
                        ) : datatable.rows.length === 0 ? (
                          <p>No operations users found.</p>
                        ) : (
                          <MDBDataTable
                            striped
                            responsive
                            bordered
                            small
                            data={datatable}
                          />
                        )}
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="update_btn"
                              style={{ textAlign: "right" }}
                            ></div>
                          </div>
                        </div>
                        <ToastContainer />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
